<script>

import personService from "@/services/person.service"
import accountService from "@/services/account.service"
import appointmentTokenService from "@/services/appointmentToken.service"
import { Form as VeeForm, Field, ErrorMessage } from "vee-validate"
import * as yup from 'yup'
import VueDatepicker from '@vuepic/vue-datepicker'
import AutoComplete from 'primevue/autocomplete'
import Icon from "@/components/Icon/Icon.vue"
import { ref } from 'vue'
import moment from 'moment'
import Dialog from 'primevue/dialog'

export default {
  name: 'AppointmentFreeModal',
  components: {
      personService,
      accountService,
      appointmentTokenService,
      VueDatepicker,
      AutoComplete,
      VeeForm,
      Field,
      ErrorMessage,
      Icon,
      Dialog,
  },
  data() {
      return {
        places: [],
        reasons: [],
        persons: [],
        dateStartCheck: null,
        dateEndCheck: null,
        duration: 0,
        selectedPersonId: null,
        selectedReason: null,
        selectedPlace: null,
        personName: '',
        showFreeModal: false,
        email: '',
      }
  },
  props: {
      externShowFreeModal: {
          type: Boolean
      },
  },
  watch: { 
      externShowFreeModal: function(newVal) {
          this.showFreeModal = newVal;
      },
  },
  created: function() {
        this.places = this.$store.state.account.places
        this.reasons = this.$store.state.account.reasons
  },
  setup() {
        const date_start = ref(moment())
        const date_end = ref(moment().add(7, 'days'))

        const textInputOptions = ref({
            format: 'dd/MM/yyyy'
        })

        const schema = yup.object().shape({
        dateStartCheck: yup.string().required("La date de début est obligatoire"),
        dateEndCheck: yup.string().required("La date de fin est obligatoire"),
        duration: yup
          .number("La durée doit être un nombre")
          .typeError("La durée doit être un nombre")
          .required("La durée est obligatoire")
          .positive("La durée doit être un nombre positif")
          .integer("La durée doit être un entier")
          .min(5, "La durée doit être supérieure à 5 minutes"),
        email: yup.string()
          .required("L'email est obligatoire")
          .email("Le format de l'email n'est pa correct"),
      })

        return {
            date_start,
            date_end,
            textInputOptions,
            schema,
        }
    },
    mounted: function() {
        this.dateStartCheck = this.date_start
        this.dateEndCheck = this.date_end

        this.selectedReason = this.reasons[0].id
        if(this.reasons[0].duration) {
          this.duration = this.reasons[0].duration
        } else {
          this.duration = this.$store.state.account.setting.duration
        }

        this.selectedPlace = this.places[0].id
    },
    methods: {
      cancel() {
          this.selectedPersonId = null
          this.personName = null
          this.email = null
      },
      beforeClose () {
          this.showFreeModal = false
          this.$emit('close', {});
      },
      close() {
        this.showFreeModal = false
      },
      search() {
          personService.search({
                account: this.$store.state.account.uuid,
                name: this.personName,
            })
            .then(data => {
                this.persons = []

                if(data['persons'].result.length)
                {
                    this.persons = [];

                    data['persons'].result.forEach((el) => {
                      this.persons.push({
                        id: el.id,
                        name: el.name,
                        email: el.email,
                        phone: el.phone,
                        note: el.note,
                      })
                    })
                }
            });
        },
        envoyerAction() {
          const uuid = this.$store.state.account.uuid;

            appointmentTokenService.create({
                  account_uuid: uuid,
                  date_start: this.date_start,
                  date_end: this.date_end,
                  duration: this.duration,
                  reason_id: this.selectedReason,
                  place_id: this.selectedPlace,
                  person_uuid: this.selectedPersonUuid,
                  email: this.email,
              }, uuid)
              .then(responsePerson => {
                  this.date_start = '';
                  this.date_end = '';
                  this.duration = 0;
                  this.selectedPersonId = null;
                  this.selectedReason = null;
                  this.selectedPlace = null;
                  this.personName = '';
                  this.email = '';

                    this.showFreeModal = false

                    return responsePerson;
                });
        },
        itemSelect($event) {
          this.selectedPersonId = $event.value.id
          this.email = $event.value.email
        },
        changeClient() {
          this.selectedPersonId = 0
        },
        changePerson() {
          if(!this.selectedPersonId)
          {
            this.personName = ''
            this.email = null
          }
        },
        changeDateStart(value) {
          if(value != null) {
            this.dateStartCheck = moment(value).format('YYYY-MM-DD')
          } else {
            this.dateStartCheck = ''
          }
        },
        changeDateEnd(value) {
          if(value != null) {
            this.dateEndCheck = moment(value).format('YYYY-MM-DD')
          } else {
            this.dateEndCheck = ''
          }
        },
        changeReasons(event) {
          const found = this.reasons.find(element => element.id == event.target.value)

          if(found.duration !== null) {
            this.duration = found.duration
          } else {
            this.duration = this.$store.state.account.setting.duration
          }
        }
  },
}

</script>

<template>
  <Dialog
        v-model:visible="showFreeModal"
        modal
        class="flex justify-center items-center"
        :showHeader="false"
        :dismissableMask="true"
        :baseZIndex="1500"
        contentClass="relative p-0 rounded-lg bg-white dark:bg-gray-900"
        @hide="beforeClose"
    >
      <header class="bg-orange-300 p-2">
        <div class="text-right">
          <div @click="close()" class="cursor-pointer">Fermer</div>
        </div>
      </header>
      <div class="m-0 px-16 py-10 relative bg-white dark:bg-gray-900 border border-orange-300">
        <VeeForm @submit="envoyerAction" :validation-schema="schema" class="flex flex-col gap-4">
              <div class="form-group grid grid-cols-form-libre gap-4">
                  <span class="flex flex-col justify-center">Date de début</span>
                  <VueDatepicker
                    v-model="date_start"
                    :clearable="true"
                    :enableTimePicker="false"
                    locale="fr"
                    cancelText="Annuler"
                    selectText="Valider"
                    format="dd/MM/yyyy"
                    :typeable="true"
                    text-input
                    :text-input-options="textInputOptions"
                    auto-apply
                    :style="{'width': '150px'}"
                    :model-value="date_start"
                    @update:model-value="changeDateStart"
                />
                <Field name="dateStartCheck" v-model="dateStartCheck" type="hidden" :validateOnBlur="false" :validateOnChange="false" :validateOnInput="false" />
              </div>
              <ErrorMessage name="dateStartCheck" v-slot="{ message }">
                <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative" role="alert">
                  {{ message }}
                </div>
              </ErrorMessage>

              <div class="form-group grid grid-cols-form-libre gap-4">
                <span class="flex flex-col justify-center">Date de fin</span>
                <VueDatepicker
                    v-model="date_end"
                    :clearable="true"
                    :enableTimePicker="false"
                    locale="fr"
                    cancelText="Annuler"
                    selectText="Valider"
                    format="dd/MM/yyyy"
                    :typeable="true"
                    text-input
                    :text-input-options="textInputOptions"
                    auto-apply
                    :style="{'width': '150px'}"
                    :model-value="date_end"
                    @update:model-value="changeDateEnd"
                />
                <Field name="dateEndCheck" v-model="dateEndCheck" type="hidden" :validateOnBlur="false" :validateOnChange="false" :validateOnInput="false" />
              </div>
              <ErrorMessage name="dateEndCheck" v-slot="{ message }">
                <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative" role="alert">
                  {{ message }}
                </div>
              </ErrorMessage>

              <div class="form-group grid grid-cols-form-libre gap-4">
                <span class="flex flex-col justify-center">Durée</span>
                <Field name="duration" v-model="duration" class="w-20 form-control form-input" type="number" />
              </div>
              <ErrorMessage name="duration" v-slot="{ message }">
                <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative" role="alert">
                  {{ message }}
                </div>
              </ErrorMessage>

              <div v-show="reasons.length > 1" class="form-group grid grid-cols-form-libre gap-4">
                <span class="flex flex-col justify-center">Motif</span>
                  <Field
                    name="reason_id"
                    @change="changeReasons"
                    as="select"
                    class="form-control w-full p-2"
                    v-model="selectedReason"
                  >
                    <!--option v-if="reasons.length > 1" value="">Sélectionner le motif</option-->
                    <option v-for="reason in reasons" :key="reason.id" :value="reason.id">{{ reason.name }}</option>
                </Field>
              </div>
              <ErrorMessage name="selectedReason" v-slot="{ message }">
                <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative" role="alert">
                  {{ message }}
                </div>
              </ErrorMessage>

              <div v-show="places.length > 1" class="form-group grid grid-cols-form-libre gap-4">
                <span class="flex flex-col justify-center">Lieu</span>
                <Field name="place_id" as="select" class="form-control w-full p-2" v-model="selectedPlace">
                  <!--option v-if="places.length > 1" value="">Sélectionner le lieu</option-->
                  <option v-for="place in places" :key="place.id" :value="place.id">{{ place.name }}</option>
                </Field>
              </div>
              <ErrorMessage name="selectedPlace" v-slot="{ message }">
                <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative" role="alert">
                  {{ message }}
                </div>
              </ErrorMessage>

              <div class="form-group flex justify-between pt-2 pb-2">
                <Field
                    name="person_id"
                    v-model="selectedPersonId"
                    @change="changePerson"
                    type="hidden"
                    class="w-8"
                    value="0"
                />

                <AutoComplete
                    name="person_name"
                    v-model="personName"
                    class="form-control form-input"
                    placeholder="Choisir le client..."
                    :suggestions="persons"
                    @complete="search"
                    @item-select="itemSelect"
                    @change="changeClient"
                    optionLabel="name"
                >
                    <template #optiongroup="slotProps">
                        <div class="flex align-items-center country-item">
                        <div id="{{ slotProps.option.id }}">{{ slotProps.option.name }}</div>
                        </div>
                    </template>
                </AutoComplete>

                <div @click="cancel()" class="flex flex-col justify-center hover:cursor-pointer">
                    <icon name="remove" :size="16" class="w-6 h-6 text-orange-300" />
                </div>
                <ErrorMessage name="person_id" class="error-feedback" />
            </div>

            <div class="form-group flex justify-between pt-2 pb-2">
                <Field
                    name="email"
                    v-model="email"
                    type="text"
                    class="form-control form-input"
                    placeholder="Email"
                />
              </div>
              <ErrorMessage name="email" v-slot="{ message }">
                <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative" role="alert">
                  {{ message }}
                </div>
              </ErrorMessage>

            <button type="submit" class="btn flex justify-center mt-10">
              <span>Envoyer</span>
            </button>
          </VeeForm>
      </div>
  </Dialog>
</template>
